import React from 'react';
import moment from 'moment';
import {Icon, Table, Upload} from 'antd';
import {CLIENT_ID, SIGN_TYPE} from '../../utils/constants';
import IconTip from '../../components/IconTip';
import {convertNumToSignType} from  '../../utils/meetingUtil';
import { FormattedMessage, injectIntl } from 'react-intl';

class MeetingSign extends React.Component {
  constructor() {
    super();
    this.state = {
      signFilter: 0
    };
  }

  render() {
    const {dispatch, meetingSign, meeting, intl} = this.props;

    const {signType = '', list = []} = meetingSign;
    const {signFilter} = this.state;

    let signTypes = String(signType).split(',');

    let hasFaceSign = signTypes.some(st => SIGN_TYPE.password == st);

    let isAllAnonymousRoom = signTypes.every(st => st == SIGN_TYPE.anonymous);

    let meetingSignData = list;
    if (signFilter == 0) {
      //需签到
    } else if (signFilter == 1) {
      //已签到
      meetingSignData = list.filter(ms => {
        return ms.isSign == '1';
      });
    } else if (signFilter == 2) {
      meetingSignData = list.filter(ms => {
        return ms.isSign == '0';
      });
    }
    let firstSign = null;
    list.filter(x=>x.signTime).map(item=> {
      if (firstSign == null) {
        firstSign = item;
      } else {
        if (item.signTime < firstSign.signTime) {
          firstSign = item;
        }
      }
    });

    const needSign = list.length;
    let hasSign = 0;
    let noSign = 0;
    list.map(ms => {
      if (ms.isSign == '1') {
        hasSign++;
      } else {
        noSign++;
      }
    });
    let columns = [
      {
        title: intl.formatMessage({id:'meeting_sing_column_name'}),
        dataIndex: 'name'
      },
      {
        title: intl.formatMessage({id:'meeting_sing_column_sign_time'}),
        key: 'signTime',
        render: record => {
          return record.signTime
            ? moment(record.signTime).format('YYYY-MM-DD HH:mm')
            : '--';
        }
      },
      {
        title: intl.formatMessage({id:'meeting_sing_column_sign_type'}),
        key: 'type',
        render: record => {
          let str = "--";
          if(record.signTime){
            let key = convertNumToSignType(record.signType);
            if(key){
              str = intl.formatMessage({id:key});
            }
          }
          return <span>{str || '--'}</span>;
        }
      },
      {
        title: intl.formatMessage({id:'meeting_sing_column_sign_img'}),
        key: 'img',
        render: record => {
          if (this.props.viewOnly) {
            return (
              <div className="user_img">
                <img
                  style={{width: '50px', height: '50px'}}
                  src={record.face}
                />
              </div>
            );
          }
          return (
            <div className="user_img">
              <Upload
                disabled={this.props.viewOnly}
                name="fileUpload"
                action={`/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
                  'token'
                )}&fromType=${CLIENT_ID}`}
                listType="picture-card"
                showUploadList={false}
                onChange={info => {
                  let file = info.file;
                  if (file.status == 'done') {
                    if (file.response.result === 0) {
                      let path = file.response.list[0].fileUrl;
                      dispatch({
                        type: 'meetingInfo/changeUserFace',
                        payload: {
                          path: path,
                          userId: record.userId,
                          userType: record.type
                        }
                      });
                    }
                  }
                }}
              >
                {record.face ? (
                  <img
                    style={{width: '50px', height: '50px'}}
                    src={record.face}
                  />
                ) : (
                  <Icon type="plus"/>
                )}
              </Upload>
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({id:'meeting_sing_column_sign_operation'}),
        key: 'operate',
        render: record => {
          if (record.isSign == '0') {
            return (
              <span
                className="main_color_btn"
                onClick={() => {
                  dispatch({
                    type: 'meetingInfo/reSign',
                    payload: {id: record.id}
                  });
                }}
              >
                <IconTip title={intl.formatMessage({id:'meeting_sign_column_resign'})} type="buqian1"/>
              </span>
            );
          } else {
            return null;
          }
        }
      }
    ];

    if (!hasFaceSign) {
      columns = columns.filter(c => {
        return c.key != 'img';
      });
    }
    return (
      <div className="meeting_sign">
        <div className="header_div">
          <span>{meeting.name}</span>
          {!isAllAnonymousRoom && <div className="export_btn" onClick={()=>{
            dispatch({type:"meetingInfo/downloadSingInfo",payload:{meetingId:meeting.id}})
          }}><FormattedMessage id="meeting_sign_btn_export"/></div>}
        </div>
        <div className="sign_top">
          <div className="sign_top_block">
            <div className="row_div">
              <div className="row_1"><FormattedMessage id="meeting_sign_label_sign_state"/>:</div>
              <div className="row_2">{hasSign>0?intl.formatMessage({id:'meeting_sign_label_has_sign'}):intl.formatMessage({id:'meeting_sign_label_no_sign'})}</div>
            </div>
          </div>
          {!isAllAnonymousRoom && <div className="sign_top_block">
            <div className="row_div">
              <div className="row_1"><FormattedMessage id="meeting_sign_label_has_sign"/>:</div>
              <div className="row_2"><span className="person_num">{hasSign || 0}</span> <FormattedMessage id="meeting_sing_label_unit_people"/></div>
            </div>
          </div>}
          {!isAllAnonymousRoom && <div className="sign_top_block">
            <div className="row_div">
              <div className="row_1"><FormattedMessage id="meeting_sign_label_no_sign"/>:</div>
              <div className="row_2"><span className="person_num">{noSign || 0}</span> <FormattedMessage id="meeting_sing_label_unit_people"/></div>
            </div>
          </div>}
          <div className="sign_top_block">
            <div className="row_div">
              <div className="row_1"><FormattedMessage id="meeting_sign_label_sign_type"/>:</div>
              <div className="row_2">{(firstSign && firstSign.signType!= 0) ?intl.formatMessage({id:convertNumToSignType(firstSign.signType)}):'--'}</div>
            </div>
          </div>
          <div className="sign_top_block">
            <div className="row_div">
              <div className="row_1"><FormattedMessage id="meeting_sign_label_sign_time"/>:</div>
              <div className="row_2">{(firstSign && firstSign.signTime)?moment(firstSign.signTime).format('YYYY-MM-DD HH:mm'):'--'}</div>
            </div>
          </div>
        </div>
        {!isAllAnonymousRoom && <div className="sign_table">
          {false && <div className="button_div">
            <span className="sign_state">
              <FormattedMessage id="sign_manage_need_attend"/> :
              <span
                className="people_num"
                onClick={() => {
                  this.setState({signFilter: 0});
                }}
              >
                &nbsp;
                {needSign}
                &nbsp;
              </span>
              <FormattedMessage id="sign_manage_unit_people"/>，<FormattedMessage id="sign_manage_sign"/>
              <span
                className="people_num"
                onClick={() => {
                  this.setState({signFilter: 1});
                }}
              >
                &nbsp;
                {hasSign}
                &nbsp;
              </span>
              <FormattedMessage id="sign_manage_unit_people"/>， <FormattedMessage id="sign_manage_not_sign"/>
              <span
                className="people_num"
                onClick={() => {
                  this.setState({signFilter: 2});
                }}
              >
                &nbsp;
                {noSign}
                &nbsp;
              </span>
             <FormattedMessage id="sign_manage_unit_people"/>
            </span>
          </div>}
          <Table
            rowKey={record => record.id}
            dataSource={meetingSignData}
            columns={columns}
            pagination={meetingSignData > 8 ? {pageSize: 8} : false}
          />
        </div> }
      </div>
    );
  }
}

export default MeetingSign;



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingSign.js